var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3906 27.0148V11.7804C38.3906 10.5184 37.3675 9.49524 36.1055 9.49524H5.63672C4.3747 9.49524 3.35156 10.5184 3.35156 11.7804V27.0148C3.35156 28.2768 4.3747 29.2999 5.63672 29.2999H36.1055C37.3675 29.2999 38.3906 28.2768 38.3906 27.0148Z",
    fill: "#F1F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26562 25.085C4.09744 25.085 3.96094 24.9485 3.96094 24.7803V13.9639C3.96094 13.7958 4.09744 13.6593 4.26562 13.6593C4.43381 13.6593 4.57031 13.7958 4.57031 13.9639V24.7803C4.57031 24.9487 4.43381 25.085 4.26562 25.085ZM4.26562 13.0499C4.09744 13.0499 3.96094 12.9134 3.96094 12.7452V12.6945C3.96094 12.5263 4.09744 12.3898 4.26562 12.3898C4.43381 12.3898 4.57031 12.5263 4.57031 12.6945V12.7452C4.57031 12.9135 4.43381 13.0499 4.26562 13.0499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45013 27.6779C3.66006 27.7414 3.88264 27.7764 4.11329 27.7764H34.582C35.8441 27.7764 36.8672 26.7533 36.8672 25.4913V10.2569C36.8672 10.0261 36.8323 9.80368 36.7686 9.59375C37.7071 9.87802 38.3906 10.749 38.3906 11.7803V27.0147C38.3906 28.2767 37.3675 29.2999 36.1055 29.2999H5.63672C4.60536 29.2999 3.73441 28.6163 3.45013 27.6779Z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68719 28.2024C4.03362 28.414 4.43932 28.538 4.87502 28.538H35.3438C36.6058 28.538 37.6289 27.5149 37.6289 26.2529V11.0185C37.6289 10.5828 37.5048 10.1771 37.2933 9.83069C37.9505 10.232 38.3906 10.9538 38.3906 11.7802V27.0146C38.3906 28.2766 37.3675 29.2998 36.1055 29.2998H5.63674C4.81027 29.2999 4.08862 28.8596 3.68719 28.2024Z",
    fill: "#D1D3D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.609375 21.6827V17.1124C0.609375 16.271 1.29142 15.589 2.13281 15.589H3.35156V23.2062H2.13281C1.29142 23.2062 0.609375 22.5241 0.609375 21.6827Z",
    fill: "#D1D3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 11.7804H11.7305V27.0148H7.16016C6.31876 27.0148 5.63672 26.3327 5.63672 25.4913V13.3038C5.63672 12.4624 6.31876 11.7804 7.16016 11.7804Z",
    fill: "#151827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63672 24.7296V25.4913C5.63672 26.3327 6.31876 27.0148 7.16016 27.0148H11.7305V26.2531H7.16016C6.31876 26.2531 5.63672 25.571 5.63672 24.7296Z",
    fill: "#648940"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1055 13.3038V25.4913C36.1055 26.3327 35.4234 27.0148 34.582 27.0148H30.0117V11.7804H34.582C35.4234 11.7804 36.1055 12.4624 36.1055 13.3038Z",
    fill: "#76A34F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2082 11.916C35.2945 12.1072 35.3438 12.3187 35.3438 12.5421V24.7296C35.3438 25.571 34.6617 26.2531 33.8203 26.2531H30.0117V27.0148H34.582C35.4234 27.0148 36.1055 26.3328 36.1055 25.4914V13.3039C36.1055 12.6858 35.7368 12.155 35.2082 11.916Z",
    fill: "#648940"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 11.7804H17.8242V27.0148H11.7305V11.7804Z",
    fill: "#91B56B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 26.2531H17.8242V27.0148H11.7305V26.2531Z",
    fill: "#76A34F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 11.7804H30.0117V27.0148H23.918V11.7804Z",
    fill: "#91B56B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 26.2531H30.0117V27.0148H23.918V26.2531Z",
    fill: "#76A34F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 11.7804V27.0148H17.8242V11.7804H23.918Z",
    fill: "#76A34F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8242 26.2531H23.918V27.0148H17.8242V26.2531Z",
    fill: "#648940"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7432 7.12769H20.4782C20.1776 7.12769 19.9051 7.3044 19.7826 7.57893L13.9446 20.6608C13.7198 21.1646 14.0884 21.733 14.6402 21.733H20.9259L17.488 31.464C17.3728 31.7899 17.8035 32.0254 18.0157 31.7527L27.7604 19.2299C28.1498 18.7296 27.7931 18.0003 27.1592 18.0003H20.915L25.435 8.20872C25.6678 7.704 25.2991 7.12769 24.7432 7.12769Z",
    fill: "#FFC91D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6731 8.20872L20.3526 17.568C20.2594 17.7698 20.4069 18.0003 20.6293 18.0003H20.9148L25.4348 8.20872C25.6678 7.704 25.2991 7.12769 24.7432 7.12769H23.9815C24.5374 7.12769 24.906 7.704 24.6731 8.20872Z",
    fill: "#FFA91A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1591 18.0004H26.3974C27.0313 18.0004 27.3879 18.7295 26.9985 19.2299L17.4956 31.442L17.4878 31.4641C17.3727 31.7899 17.8033 32.0254 18.0156 31.7526L27.7601 19.2298C28.1496 18.7296 27.793 18.0004 27.1591 18.0004Z",
    fill: "#FFA91A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyHorizontal);
export default __webpack_public_path__ + "static/media/energy-horizontal.76ecb1ef3426f05a7fe5c4168e67f4cc.svg";
export { ForwardRef as ReactComponent };